import React from "react";
import { node } from "prop-types";
import Heading from "../../Heading";
import { Col, Container, Row } from "../../Grid";
import Section from "../../Section";

const SectionSearchBar = ({ children }) => {
	return (
		<Section className="section-search-bar">
			<Container>
				<Row px utility={{ justify: "center" }}>
					<Col sm={12} md={11} lg={8}>
						{children}
					</Col>
				</Row>
			</Container>
		</Section>
	);
};

SectionSearchBar.propTypes = {
	children: node.isRequired,
};

const Title = ({ children }) => {
	return (
		<Heading Tag="h2" sx={{ fontSize: "xl", textAlign: "center" }} spacing={{ mt: 0, mb: 2 }}>
			{children}
		</Heading>
	);
};

Title.propTypes = {
	children: node.isRequired,
};

SectionSearchBar.Title = Title;

export default SectionSearchBar;
